<template>
  <div>
    <div class="CourseHead">
      <div class="CourseSearch">
        <span style="font-size: 18px;padding: 20px">搜索课程</span>
        <input v-model="trainCourse.title" class="CourseSearchBox" type="text" placeholder="课程名称关键字搜索">
        <el-button slot="append" icon="el-icon-search" @click="performSearch"></el-button>
      </div>
      <!-- <div class="CoursePopular"><span
          style="color: #666666">热门搜索:集团管控&nbsp;&nbsp;|&nbsp;&nbsp;收放应循四原则&nbsp;&nbsp;|&nbsp;&nbsp;竞争策略&nbsp;&nbsp;|&nbsp;&nbsp;企业管理</span>
      </div> -->
      <div style="width: 64%;margin-bottom: 24px">
        <div class="TypeList">
          <div style="width: 10%; font-size: 18px">课程分类:</div>
          <div style="width: 93%">
            <button v-for="(item, index) in kechengList" :key="index"
              :class="[item.buttonfl ? 'CourseButtonR' : 'CourseButtonB']" @click="kcfl(item.id)">
              {{ item.categorizeName }}</button>
          </div>
        </div>
        <div class="TypeList">
          <div style="width: 10%; font-size: 18px">相关行业:</div>
          <div style="width: 93%">
            <button v-for="(item, index) in hangyeList" :key="index"
              :class="[item.buttonfl ? 'CourseButtonR' : 'CourseButtonB']" @click="xghy(item.dictValue)">
              {{ item.dictLabel }}</button>
          </div>
        </div>
        <div class="TypeList">
          <div style="width: 10%; font-size: 18px">相关专业:</div>
          <div style="width: 93%">
            <button v-for="(item, index) in zhuanyeList" :key="index"
              :class="[item.buttonfl ? 'CourseButtonR' : 'CourseButtonB']" @click="xgzy(item.dictValue)">
              {{ item.dictLabel }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="CourseBody">
      <div style="width: 66%;margin: 26px 0">
        <div style="font-weight: bold;font-size: 16px; color: #333333">相关课程:<span style="color: #D00E11">{{
          CourseList.length }}</span>个课程</div>
      </div>
      <div class="CoursesBody">
        <div class="Courses" v-for="(item, index) in CourseList" :key="index">
          <div style="padding: 0 16px">
            <img :src="item.pic" alt="" style="width: 257px">
          </div>
          <div>
            <p class="CourseName" @click="CourseDetails(item.id, item.lecturerId)">{{ item.title }}</p>
            <div style="color: #666666;margin-bottom: 20px">
              <span style="margin-right: 25px;">讲师:{{ item.name }}</span>
              <img src="https://www.zljst.com/img/subpage/find_course/course/address.png" alt=""
                style="vertical-align: 0">&nbsp{{ item.site }}
            </div>
            <div class="course_describe" @click="CourseDetails(item.id, item.lecturerId)">
              {{ item.course_content }}
            </div>
            <div style="font-size: 14px">
              课程领域：{{ item.course_content }}
            </div>
          </div>
        </div>
      </div>
      <div class="block" style="margin: 10px 0;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[5, 10, 15]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>




<script>

export default {
  name: "AllCourse",
  data() {
    return {
      trainCourse: {
        title: '',    //课程名称关键字搜索
      },
      kechengList: [],
      zhuanyeList: [],
      hangyeList: [],
      CourseList: [],
      currentPage: 1,
      pageSize: 5,
      total: 0, // 假设总共有100项
    }

  },

  // 页面加载的时候调用
  created() {
    this.getHangyeList();
    this.getZhuanyeList();
    this.getKeChengList();
    this.getCourseList();
  },

  methods: {


    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 切换每页显示数量后重置到第一页
      this.getCourseList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCourseList();
    },

    CourseDetails(res, lecturerId) {
      this.$router.push({ name: "courseDetail", params: { id: res, lecturerId: lecturerId } });
    },
    performSearch() {
      this.getCourseList();
    },
    //查询课程列表
    getCourseList() {
      let _this = this;
      let parmas = {
        ..._this.trainCourse,
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
      };
      _this.$api.courseZ
        .getCourseList(parmas)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.CourseList = res.rows;
            _this.total = Number(res.total);
          }
        })
        .catch(() => { });
    },


    /** 查询相关课程 */
    getKeChengList() {
      let _this = this;
      _this.$api.courseZ.getKeChengList().then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          console.log("相关课程", res)
          _this.kechengList = res.data;
        }
      })
        .catch(() => {
        });
    },

    xgzy(dictValue) {
      this.trainCourse.relatedMajors = dictValue;
      this.getCourseList();
    },
    xghy(dictValue) {
      this.trainCourse.industryType = dictValue;
      this.getCourseList();
    },
    kcfl(id) {
      this.trainCourse.categorizeId = id;
      this.getCourseList();
    },


    /** 查询相关行业 */
    getHangyeList() {
      let _this = this;
      let param = {
        dictType: 'related_industry',
      };
      _this.hangyeList = [{
        dictLabel: '全部',
        dictValue: ''
      }]
      _this.$api.system.getDicByCode(param).then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          console.log("相关行业", res)
          _this.hangyeList.push(...res.data);
        }
      })
        .catch(() => {
        });
    },
    /** 查询相关专业 */
    getZhuanyeList() {
      let _this = this;
      let param = {
        dictType: 'related_majors',
      };
      _this.zhuanyeList = [{
        dictLabel: '全部',
        dictValue: ''
      }]
      _this.$api.system.getDicByCode(param).then((res) => {
        if (res.code == _this.$commons.RespCode.success) {
          console.log("相关专业", res)
          _this.zhuanyeList.push(...res.data);
        }
      })
        .catch(() => {
        });
    },
  }
}
</script>

<style scoped>
.CourseHead,
.CourseSearch,
.CoursePopular,
.CourseBody {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.CourseHead,
.CourseBody {
  flex-direction: column;
}

.CourseBody {
  height: 80%;
  background-color: #F6F6F6;
}

.CourseSearchBox {
  width: 40%;
  height: 38px;
  font-size: 18px;
  border: 1px solid #CED4DA;
  padding: 8px;
}

.TypeList {
  width: 100%;
  padding: 12px 0;
  display: flex;

}

.CourseButtonR,
.CourseButtonB {
  margin-left: 8px;
  padding: 8px;
  text-align: center;
  font-size: 12px;
  border-radius: 3px;
  margin-bottom: 8px;
}

.CourseButtonR {
  background-color: #D00E11;
  color: #FFFFFF;
}

.CourseButtonB {
  background-color: #F7F7F7;
  color: #333333;
}

.CourseButtonR:hover,
.CourseButtonB:hover {
  background-color: #D00E11;
  color: #FFFFFF;
}

.Courses {
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  margin-bottom: 30px;
  padding: 14px 0;
}

.CoursesBody {
  width: 66%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
}

.CourseName {
  font-size: 18px;
  font-weight: bold;
}

.course_describe {
  font-size: 14px;
  color: #666666;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.CourseName:hover,
.course_describe:hover {
  color: #D52330;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/server/allCourse.vue